/**
 * Signature utility functions
 */

/**
 * Check if a canvas has been drawn on
 * @param {HTMLCanvasElement} canvas - The canvas element to check
 * @returns {boolean} True if the canvas has content drawn on it
 */
export function isDrawnOn(canvas) {
  if (!canvas) return false

  const context = canvas.getContext('2d')
  const imageData = context.getImageData(0, 0, canvas.width, canvas.height)
  const data = imageData.data

  // Check if any pixel has been modified (not fully transparent)
  for (let i = 3; i < data.length; i += 4) {
    // Check alpha channel
    if (data[i] > 0) {
      return true
    }
  }

  return false
}

/**
 * Convert canvas to Blob
 * @param {HTMLCanvasElement} canvas - The canvas element
 * @param {string} type - Image type (default: 'image/png')
 * @param {number} quality - Image quality for jpeg (0-1)
 * @returns {Promise<Blob>} The canvas as a Blob
 */
export function canvasToBlob(canvas, type = 'image/png', quality = 0.92) {
  return new Promise((resolve) => {
    canvas.toBlob(
      (blob) => {
        resolve(blob)
      },
      type,
      quality
    )
  })
}

/**
 * Clear a canvas
 * @param {HTMLCanvasElement} canvas - The canvas element to clear
 */
export function clearCanvas(canvas) {
  if (!canvas) return

  const context = canvas.getContext('2d')
  context.clearRect(0, 0, canvas.width, canvas.height)
}
